<script>
import BulletinPaie from "@/views/OutState/Components/BulletinPaie.vue";
import useSharedData from "@/use/SharedData";
import useSharedMethod from "@/use/SharedMethod";

export default {
    components: {BulletinPaie},
    setup() {
        const {dialog} = useSharedData();
        const {getBack} = useSharedMethod();
        
        return {
            dialog,
            getBack
        }
    }
}
</script>

<template>
    <div>
        <v-dialog v-model="dialog" scrollable persistent max-width="1200">
            <v-card flat>
                <w-toolbar color="teal" :title="$t('pay_slip.bulletin')"/>
                <v-card-text>
                    <bulletin-paie
                        :annex-id="$route.params.annexId"
                    />
                </v-card-text>
                <v-divider/>
                <v-card-actions>
                    <v-spacer/>
                    <w-btn-close @press="getBack"/>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>